/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens.
 */

if ( 'loading' === document.readyState ) {
	// The DOM has not yet been loaded.
	document.addEventListener( 'DOMContentLoaded', initNavigation );
} else {
	// The DOM has already been loaded.
	initNavigation();
}

// Initiate the menus when the DOM loads.
function initNavigation() {
	initNavToggleMain();
	initNavToggleSubmenus();
}

/**
 * Toggles the mobile navigation when clicking on the burger icon.
 */
function initNavToggleMain() {
	const navToggle = document.querySelector( '.js-navigation-toggle' );

	// Bail early, if menu isn't found.
	if ( navToggle.length < 1 ) {
		return;
	}

	navToggle.addEventListener( 'click', () => {
		document.body.classList.toggle( 'is-mobile-navigation-open' );
	});
}

/**
 * Toggles the submenu for the selected menu item.
 */
function initNavToggleSubmenus() {
	const submenuToggle = document.querySelectorAll( '.js-navigation-open_submenu' );

	[ ...submenuToggle ].map((item) => {
		item.addEventListener( 'click', function( event ) {
			event.preventDefault();

			const submenu    = this.nextElementSibling;
			const backButton = submenu.querySelector( '.js-navigation-back' );

			submenu.classList.add( 'is-open' );

			backButton.addEventListener( 'click', () => {
				submenu.classList.remove( 'is-open' );
			} );
		} );
	});
}
